import {apiRequest} from "./apiRequest";
import type {PipelineStatusResponse, PipelineTargetSummary} from "@calendall/shared";

/** An empty list means this environment shows no pipeline. */
export async function getPipelines(): Promise<PipelineTargetSummary[]> {
  return apiRequest<PipelineTargetSummary[]>({path: "admin/pipelines"});
}

export async function getPipelineStatus(pipelineName: string): Promise<PipelineStatusResponse> {
  return apiRequest<PipelineStatusResponse>({path: `admin/pipelines/${encodeURIComponent(pipelineName)}/status`});
}
